/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestigationError
 */
export interface InvestigationError {
    /**
     * 
     * @type {string}
     * @memberof InvestigationError
     */
    context?: InvestigationErrorContextEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationError
     */
    severity?: InvestigationErrorSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestigationError
     */
    description?: string;
}


/**
 * @export
 */
export const InvestigationErrorContextEnum = {
    Lei: 'LEI',
    LegalName: 'LEGAL_NAME',
    Domain: 'DOMAIN',
    Ssl: 'SSL'
} as const;
export type InvestigationErrorContextEnum = typeof InvestigationErrorContextEnum[keyof typeof InvestigationErrorContextEnum];

/**
 * @export
 */
export const InvestigationErrorSeverityEnum = {
    Error: 'ERROR',
    Warn: 'WARN'
} as const;
export type InvestigationErrorSeverityEnum = typeof InvestigationErrorSeverityEnum[keyof typeof InvestigationErrorSeverityEnum];


/**
 * Check if a given object implements the InvestigationError interface.
 */
export function instanceOfInvestigationError(value: object): boolean {
    return true;
}

export function InvestigationErrorFromJSON(json: any): InvestigationError {
    return InvestigationErrorFromJSONTyped(json, false);
}

export function InvestigationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestigationError {
    if (json == null) {
        return json;
    }
    return {
        
        'context': json['context'] == null ? undefined : json['context'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function InvestigationErrorToJSON(value?: InvestigationError | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'context': value['context'],
        'severity': value['severity'],
        'description': value['description'],
    };
}

